export default __webpack_public_path__ + "6aa81602e07845dde783d95da48f0db1.png";